/* eslint-disable-next-line */
import React, {useEffect, lazy, Suspense, useMemo} from "react";
import { useDispatch} from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import {update_device_data, auth_token_update} from './actions/action-creators/state-update';
import './assets/css/bootstrap5/bootstrap.min.css';
//Css
import './assets/css/main/style-main.css?v=2.3';
import './assets/css/style.css?v=4';
// import logo from './assets/images/main/logo/ifspd_logo_m.png';
// import './assets/css/main/css.css';
// import './assets/css/main/styles.css';
// import './assets/css/main/style.min.css';
// import './assets/css/main/front-flex.min.css';
// import './assets/css/main/unsemantic-grid.min.css';
// import './assets/css/main/mobile.min.css';
// import './assets/css/main/font-icons.min.css';

// import './assets/css/main/jquery.fancybox.min.css';
// import './assets/css/main/frontend.css';
// import './assets/css/main/all.css';
// import './assets/css/main/v4-shims.css';
// import './assets/css/main/style1.min.css';
// import './assets/css/main/style-mobile.min.css';
// import './assets/css/main/sticky.min.css';
// import './assets/css/main/offside.min.css';
// import './assets/css/main/icons.min.css';
// import './assets/css/main/navigation-branding.min.css';
// import './assets/css/main/main.css';


// import './assets/css/style.css';
// import './assets/css/font-awesome.min.css';
// import './assets/css/LineIcons.4.0.css';
// import Header from './components/header';
// import {Footer} from './components/footer';
import NotFound from './screens/404';
import {LoaderMedium} from './components/loader';
// const Home = lazy(() => import('./screens/home'));
import Home from './screens/home';
// About
import History from './screens/about/history';
import Founder from './screens/about/founders';
import Principle from './screens/about/principle';
// Organization
import Committee from './screens/organization/committee';
// import LegalEntity from './screens/organization/legal-entity';
import Team from './screens/organization/team';
// import OurPartner from './screens/organization/partner';
// Fellow
// import FellowProfile from './screens/fellow/profile';
// import FellowDetail from './screens/fellow/detail';
import FellowProfile from './screens/fellow/profile-new';
import FellowDetail from './screens/fellow/profile-detail-new';
// import Presidential from "./screens/fellow/presidential";
import FellowAbout from "./screens/fellow/about";
import FellowCampg from "./screens/fellow/campaign";
import Sustainability from "./screens/fellow/sustainability";
import FellowProfileForm from "./screens/fellow/profile-form";
//Affiliate
import AffiliateForm from './screens/affiliate/form';
import AffiliateVerification from './screens/affiliate/verification';
//Academy
import AcademyTender from './screens/academy/tender';
//Nomination
import SchoolNomination from './screens/school/nomination';
//Login
import Login from './screens/auth/login';
import Register from './screens/auth/register';
import Logout from "./screens/auth/logout";
import SignUp from "./screens/auth/signup";
//Private-Portfolio
// import PortfolioForm from "./screens/portfolio/form";
import PortfolioDetail from './screens/portfolio/detail';
import PortfolioEdit from './screens/portfolio/edit';
import PortPage from './screens/portfolio/port';
import PortFellowship from "./screens/portfolio/fellowship";
// import PortInsight from './screens/portfolio/insight';
// import PortfolioMain from './screens/portfolio/landing';
// import PortfolioFollower from './screens/portfolio/follower';
// import PortfolioFollowing from './screens/portfolio/following';
// import PortDemo from './screens/portfolio/demo';
import PortRecommend from './screens/portfolio/recommend';
//School
import SchoolDetail from './screens/school/detail';
// Hub
import HubDetail from './screens/hub/detail';
import HubList from './screens/hub/list';
// Glosco
import GloscoMain from './screens/static/glosco';
// ESG-SDG Specialist (CR-ifspd-esg-sdg-01)
import EsgSdgSpecialist from './screens/static/esg-sdg-specialist';
// Social Start-Up
import SocialForm from './screens/social/form';
import SocialFormMy from './screens/social/list';
import SocialDetails from './screens/social/details';
import SocialMaster from './screens/social/landing';
// Payment
import PayMaster from './screens/payment/landing';
import PayStatus from './screens/payment/status';
//Gamification
import RewardPoint from "./screens/reward/point";
import Reward from "./screens/reward/list";
// Certification
import LeaderCertification from "./screens/fellow/certification/young-leader";
// Gallery
import Gallery from './screens/gallery/gallery';
import Contact from './screens/contact';
// Static
import PrivacyPolicy from './screens/static/privacy-policy';
import TermsCondition from "./screens/static/terms-conditions";
// Events
import Events from './screens/event/list';
import Event1 from './screens/event/1';
import Event2 from './screens/event/2';
import Event3 from './screens/event/3';
import Event4 from './screens/event/4';
import Event5 from './screens/event/5';
import Event6 from './screens/event/6';
import Event7 from './screens/event/7';
import Event8 from './screens/event/8';
import Event9 from './screens/event/9';
import Event10 from './screens/event/10';

import WrapMaster from './components/wrapper/main';
// const loading = (
//     <div className="preloader flex-column justify-content-center align-items-center">
//       <img className="animation__shake" src={logo} alt="IFSPD" height="200" width="200" />
//     </div>
// )
//Public
// const Home = lazy(() => import('./screens/home'));
// const WrapMaster = lazy(() => import('./components/wrapper/main'));
import PrivateRoute from "./routes/private";
import AuthRoute from "./routes/auth";
import { alertNotification, alertResponseMessage } from "./actions/action-creators/response";
// Notification
import { requestNotifyPermission, messaging } from "./notification/firebase";
import { onMessage } from "firebase/messaging";
import { CoinAnimationProvider } from "./context/CoinAnimationContext";
import SidebarWrapper from "./components/wrapper/sidebar";

function App() {
    const dispatch = useDispatch();
    const logoutBroadcast = useMemo(() => new BroadcastChannel('ifspd-logout'), []);
    // const getDeviceId = () => {
    //     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    //       var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    //       return v.toString(16);
    //     });
    // }
    useEffect(() => {
        if(localStorage.getItem("token")){
            requestNotifyPermission();
            onMessage(messaging, (payload) => {
                alertNotification({title: payload.notification.title || "",
                                message: payload.notification.body || ""});
            });
        }
        //Check if Device Id Set, if not Set New
        if(!localStorage.getItem("device_id")){
            const deviceID = uuidv4();
            //Dispatch and check if it is available in database
            update_device_data({device_id: deviceID});
            // console.log(deviceID, 'deviceID')
        }
        // else{
        //     console.log('nnnnnnnnnnnn')
        // }
        dispatch(auth_token_update());
        // window.addEventListener("beforeunload", e => {
        //     // console.log(e.data);
        //     localStorage.removeItem('eva-session');
        //     console.log('jjjjjjj')
        // });
        const handleLogout = (e) => {
            const windowPath = window.location.pathname.split('/')[1];
            if(e.currentTarget.name === 'ifspd-logout'
                && e.data === 'logout'
                && windowPath !== 'logout'
                // && e.source !== self
            ){
                alertResponseMessage({alert_type: 1, message: "Logged out Successfully"});
                window.location.reload();
            }
        }
        
        logoutBroadcast.addEventListener("message", handleLogout);
        return () => logoutBroadcast.removeEventListener("message", handleLogout);
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
      
    return (
        <>
        {/* <Suspense fallback={loading}> */}
        <div id="bodyOverlay">
            <LoaderMedium size={65} />
        </div>
        <ReactNotification />
        <CoinAnimationProvider>
        {/* <Header/> */}
        {/* <Navbar /> */}
        {/* <div className="wrapper" style={{minHeight: '70vh'}}> */}
            {/* <div className="container"> */}
            
            <Router>
                <Routes>
                    <Route path='*' element={<NotFound/>} />
                    {/* Auth: Guest Route */}
                    <Route element={<AuthRoute/>}>
                        {/* <Route exact path='/login' element={<WrapMaster showLogo={false} showBot={false} bgGrey={false}><Login/></WrapMaster>}/> */}
                        <Route path='/login' element={<RedirectExternal url="https://portahead.com/login" />} />
                        {/* <Route exact path='/sign' element={<WrapMaster showLogo={true} showLogin={true} showBot={false} bgGrey={false}><SignUp/></WrapMaster>}/> */}
                        <Route path='/sign' element={<RedirectExternal url="https://portahead.com/sign" />} />
                        {/* <Route exact path='/register' element={<WrapMaster showLogo={false} showBot={false} bgGrey={false}><Register/></WrapMaster>}/> */}
                        <Route path='/register' element={<RedirectExternal url="https://portahead.com/register" />} />
                        {/* <Route exact path='/reset-password' element={<ResetPassword/>}/> */}
                    </Route>
                    {/* Affiliate */}
                    <Route exact path="/affiliate" element={<WrapMaster bgGrey={false}><AffiliateForm/></WrapMaster>}/>
                    <Route exact path="/affiliate/verification" element={<WrapMaster bgGrey={false}><AffiliateVerification/></WrapMaster>}/>
                    {/* Social Start Up */}
                    {/* <Route exact path="/start" element={<WrapMaster showPartner={false} showLogin={true} trimFooter={true}><SocialMaster/></WrapMaster>}/> */}
                    {/* <Route exact path="/reference-letter" element={<WrapMaster showPartner={false} showBot={false} bgGrey={false}><PortRecommend/></WrapMaster>}/> */}
                    <Route path='/reference-letter' element={<RedirectExternal url="https://portahead.com/reference-letter" />} />
                    <Route exact path="/fellowships" element={<WrapMaster showLogo={true} showPartner={false} showBot={true} bgGrey={false}><PortFellowship/></WrapMaster>}/>
                    {/* <Route exact path="/port-demo" element={<WrapMaster showPartner={false} footerClass={`mt-0`} trimFooter={true}><PortDemo/></WrapMaster>}/> */}
                    {/* Routh For Authenticated User */}
                    <Route element={<PrivateRoute/>}>
                        {/* <Route exact path='/verification' element={<Verification/>}/> */}
                        {/* <Route exact path="/port" element={<WrapMaster><PortfolioForm/></WrapMaster>}/> */}
                        {/* <Route exact path="/port" element={<WrapMaster showPartner={false} footerClass={`mt-0`} trimFooter={true}><SidebarWrapper><PortPage/></SidebarWrapper></WrapMaster>}/> */}
                        <Route path='/port' element={<RedirectExternal url="https://portahead.com/port" />} />
                        {/* Payment */}
                        {/* <Route exact path="/pay" element={<WrapMaster showLogo={false} showPartner={false} showBot={false} bgGrey={false}><PayMaster/></WrapMaster>}/> */}
                        <Route path='/pay' element={<RedirectExternal url="https://portahead.com/pay" />} />
                        {/* <Route exact path="/payment/:payment_status" element={<WrapMaster showLogo={false} showPartner={false} showBot={false} bgGrey={false}><PayStatus/></WrapMaster>}/> */}
                        <Route path='/payment/:payment_status' element={<RedirectExternal url="https://portahead.com/pay" />} />
                        {/* Port */}
                        {/* <Route exact path="/port/edit" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showBot={false}><PortfolioEdit/></WrapMaster>}/> */}
                        <Route path='/port/edit' element={<RedirectExternal url="https://portahead.com/port/edit" />} />
                        {/* <Route exact path="/my-port/followers" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showBot={false}><PortfolioFollower/></WrapMaster>}/>
                        <Route exact path="/my-port/following" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showBot={false}><PortfolioFollowing/></WrapMaster>}/> */}
                        {/* <Route exact path="/my-port/followers" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showBot={false}><SidebarWrapper><PortPage/></SidebarWrapper></WrapMaster>}/> */}
                        <Route path='/my-port/followers' element={<RedirectExternal url="https://portahead.com/my-port/followers" />} />
                        {/* <Route exact path="/my-port/following" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showBot={false}><SidebarWrapper><PortPage/></SidebarWrapper></WrapMaster>}/> */}
                        <Route path='/my-port/following' element={<RedirectExternal url="https://portahead.com/my-port/following" />} />
                        {/* <Route exact path="/port/insights" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showBot={false}><SidebarWrapper><PortPage/></SidebarWrapper></WrapMaster>}/> */}
                        <Route path='/port/insights' element={<RedirectExternal url="https://portahead.com/port/insights" />} />
                        {/* Reward */}
                        {/* <Route exact path="/reward-points" element={<WrapMaster showPartner={false} trimFooter={true} showBot={false}><RewardPoint/></WrapMaster>}/> */}
                        <Route path='/reward-points' element={<RedirectExternal url="https://portahead.com/reward-points" />} />
                        {/* <Route exact path="/rewards" element={<WrapMaster showPartner={false} trimFooter={true} showBot={false}><SidebarWrapper><Reward/></SidebarWrapper></WrapMaster>}/> */}
                        <Route path='/rewards' element={<RedirectExternal url="https://portahead.com/rewards" />} />
                        {/* Social Start-Up */}
                        {/* <Route exact path="/social-startup/create" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true}><SocialForm/></WrapMaster>}/> */}
                        {/* <Route exact path="/social-startup/edit" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true}><SocialForm/></WrapMaster>}/> */}
                        {/* <Route exact path="/social-startup/my" element={<WrapMaster showValidity={true} showLogo={false} showPartner={false} trimFooter={true}><SocialFormMy/></WrapMaster>}/> */}
                        {/* <Route exact path="/social-startup/details/:startup_id/:startup_url" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true} showLogo={false}><SocialDetails/></WrapMaster>}/> */}
                    </Route>
                    {/* <Route exact path="/port/:profile_id" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true}><PortfolioDetail/></WrapMaster>}/> */}
                    <Route path='/port/:profile_id' element={<RedirectExternal url="https://portahead.com/port" />} />
                    {/* School */}
                    {/* <Route exact path="/school/:school_slug/:branch_slug" element={<WrapMaster showValidity={true} showPartner={false} trimFooter={true}><SchoolDetail/></WrapMaster>}/> */}
                    {/* Hub */}
                    {/* <Route exact path="/hub" element={<WrapMaster showPartner={false} trimFooter={true} bgGrey={false}><HubList/></WrapMaster>}/> */}
                    <Route path='/hub' element={<RedirectExternal url="https://portahead.com/hub" />} />
                    {/* <Route exact path="/hub/:hub_url" element={<WrapMaster showPartner={false} trimFooter={true} bgGrey={false}><HubDetail/></WrapMaster>}/> */}
                    <Route path='/hub/:hub_url' element={<RedirectExternal url="https://portahead.com/hub" />} />
                    {/* <Route exact path='/logout' element={<WrapMaster showLogo={false} showBot={false} bgGrey={false}><Logout/></WrapMaster>}/> */}
                    {/* Glosco */}
                    <Route exact path='/glosco' element={<WrapMaster showLogo={false} bgGrey={false}><GloscoMain/></WrapMaster>}/>
                    {/* CR-ifspd-esg-sdg-01 */}
                    <Route exact path='/academy/esg-sdg-specialist' element={<WrapMaster showLogo={true} showPartner={false} showBot={true} bgGrey={false}><EsgSdgSpecialist/></WrapMaster>}/>
                    {/* Public Route */}
                    {/* <Route path='/' element={<PublicRoute/>} /> */}
                    {/* <Route path='/'>
                        <PublicRoute />
                    </Route> */}
                    {/* <Route element={<NotFound/>} /> */}
                    {/* Public Route */}
                    <Route exact path="/" element={<WrapMaster><Home/></WrapMaster>}/>
                    <Route exact path="/home" element={<WrapMaster bgGrey={false}><Home/></WrapMaster>}/>
                    {/* About */}
                    <Route exact path="/history" element={<WrapMaster bgGrey={false}><History/></WrapMaster>}/>
                    <Route exact path="/founders" element={<WrapMaster bgGrey={false}><Founder/></WrapMaster>}/>
                    <Route exact path="/principles-and-objectives" element={<WrapMaster bgGrey={false}><Principle/></WrapMaster>}/>
                    {/* Fellow */}
                    <Route exact path="/fellow-profiles" element={<WrapMaster bgGrey={false} showPartner={false} footerClass={`mt-0`} trimFooter={true}><FellowProfile/></WrapMaster>}/>
                    <Route exact path="/fellow-profile/:profile_id" element={<WrapMaster bgGrey={false} showPartner={false} trimFooter={true}><FellowDetail/></WrapMaster>}/>
                    <Route exact path="/fellow-profile-form" element={<WrapMaster showPartner={false} trimFooter={true} bgGrey={false}><FellowProfileForm/></WrapMaster>}/>
                    {/* Apply */}
                    <Route path='/apply' element={<RedirectExternal url="https://admin.gosurvey.in/survey/parent" />} />
                    {/* <Route path='/join' element={<RedirectExternal url="https://us06web.zoom.us/j/86536856156?pwd=ottYX2K6ZaOrbKlbSERz3G5ns6XM8d.1" />} /> */}
                    <Route path='/join' element={<RedirectExternal url="https://teams.microsoft.com/l/meetup-join/19:meeting_N2E1ZTBhMjQtMjJjNi00ZmVmLThkNDMtN2FlNjczNTI2MmM1@thread.v2/0?context=%7B%22Tid%22:%22e1c16c17-9940-4359-b5ff-bd35694e5c12%22,%22Oid%22:%221d5c59e0-7ba8-45ad-aade-b0382a548727%22%7D" /> } />                    
                    {/* Portfolio Form */}
                    {/* <Route exact path="/portfolio-form" element={<WrapMaster><PortfolioForm/></WrapMaster>}/> */}
                    {/* <Route exact path="/fp" element={<WrapMaster showLogo={false}><Presidential/></WrapMaster>}/> */}
                    <Route exact path="/fp" element={<WrapMaster showLogo={false} bgGrey={false}><FellowCampg showHeader={true} /></WrapMaster>}/>
                    <Route exact path="/global-sustainability-certification" element={<WrapMaster showLogo={false} bgGrey={false}><Sustainability showHeader={true} /></WrapMaster>}/>
                    <Route exact path="/young-leader-certification" element={<WrapMaster showLogo={false} showPartner={false} bgGrey={false}><LeaderCertification showHeader={true}/></WrapMaster>}/>
                    <Route exact path="/fellowship" element={<WrapMaster showLogo={false} bgGrey={false}><FellowAbout/></WrapMaster>}/>
                    <Route exact path="/host" element={<WrapMaster showPartner={false} bgGrey={false}><AcademyTender/></WrapMaster>}/>
                    <Route exact path="/school/nomination" element={<WrapMaster showPartner={false} bgGrey={false}><SchoolNomination/></WrapMaster>}/>
                    <Route exact path="/fellowships/application" element={<WrapMaster showPartner={false} bgGrey={false}><SchoolNomination/></WrapMaster>}/>
                    <Route exact path="/campaign" element={<WrapMaster showLogo={false} showHeader={false} showFooter={false} bgGrey={false}><FellowCampg/></WrapMaster>}/>
                    {/* <Route exact path="/fellowship-campaign" element={<WrapMaster showLogo={false} showHeader={false} showFooter={false}><FellowCampg/></WrapMaster>}/> */}
                    {/* Organization */}
                    <Route exact path="/presidential-committee" element={<WrapMaster bgGrey={false}><Committee/></WrapMaster>}/>
                    {/* <Route exact path="/legal-entity" element={<WrapMaster><LegalEntity/></WrapMaster>}/> */}
                    <Route exact path="/our-team" element={<WrapMaster bgGrey={false}><Team/></WrapMaster>}/>
                    {/* <Route exact path="/our-partners" element={<WrapMaster><OurPartner/></WrapMaster>}/> */}
                    {/* Gallery */}
                    <Route exact path="/gallery" element={<WrapMaster bgGrey={false}><Gallery/></WrapMaster>}/>
                    <Route exact path="/contact" element={<WrapMaster bgGrey={false}><Contact/></WrapMaster>}/>
                    {/* Static */}
                    <Route exact path="/privacy-policy" element={<WrapMaster bgGrey={false}><PrivacyPolicy/></WrapMaster>}/>
                    <Route exact path="/terms-and-conditions" element={<WrapMaster bgGrey={false}><TermsCondition/></WrapMaster>}/>

                    {/* Events */}
                    <Route exact path="/board-meetings" element={<WrapMaster bgGrey={false}><Events/></WrapMaster>}/>
                    <Route exact path="/board-meetings/resolutions-of-18th-board-of-directors-meeting" element={<WrapMaster bgGrey={false}><Event1/></WrapMaster>}/>
                    <Route exact path="/board-meetings/18th-ifspd-board-of-directors-meeting-held-in-belgrade-serbia" element={<WrapMaster bgGrey={false}><Event2/></WrapMaster>}/>
                    <Route exact path="/board-meetings/ifspd-17th-extended-board-of-directors-and-general-assembly-meetings" element={<WrapMaster bgGrey={false}><Event3/></WrapMaster>}/>
                    <Route exact path="/board-meetings/resolution-of-16th-general-assembly-meeting" element={<WrapMaster bgGrey={false}><Event4/></WrapMaster>}/>
                    <Route exact path="/board-meetings/resolution-of-16th-board-of-directors-meeting" element={<WrapMaster bgGrey={false}><Event5/></WrapMaster>}/>
                    <Route exact path="/board-meetings/16th-board-of-directors-and-general-assembly-meeting" element={<WrapMaster bgGrey={false}><Event6/></WrapMaster>}/>
                    <Route exact path="/board-meetings/the-anniversary-general-assembly-and-12th-board-meeting" element={<WrapMaster bgGrey={false}><Event7/></WrapMaster>}/>
                    <Route exact path="/board-meetings/the-15th-board-of-directors-and-general-assembly-meeting" element={<WrapMaster bgGrey={false}><Event8/></WrapMaster>}/>
                    <Route exact path="/board-meetings/the-15th-meeting-of-the-board-of-directors-and-general-assembly-of-the-bscsif" element={<WrapMaster bgGrey={false}><Event9/></WrapMaster>}/>
                    <Route exact path="/board-meetings/the-14th-general-assembly-and-board-meeting-of-the-bscsif-baku-azerbaijan" element={<WrapMaster bgGrey={false}><Event10/></WrapMaster>}/>   
                </Routes>
                {/* <PublicRoute /> */}
            </Router>
            
            {/* </div> */}
        {/* </div> */}
        {/* <Footer /> */}
        {/* </Suspense> */}
        </CoinAnimationProvider>
        </>
    );
}
function RedirectExternal(props) {
    window.location.href = props.url;
    return null;
}
export default App;